"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroup = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const react_1 = tslib_1.__importStar(require("react"));
const InputGroup = ({ children }) => {
    const styles = (0, ui_1.useStyles2)(getStyles);
    // Find children with an invalid prop, and set a class name to raise their z-index so all
    // of the invalid border is visible
    const modifiedChildren = react_1.Children.map(children, (child) => {
        if ((0, react_1.isValidElement)(child) && child.props.invalid) {
            return (0, react_1.cloneElement)(child, { className: (0, css_1.cx)(child.props.className, styles.invalidChild) });
        }
        return child;
    });
    return react_1.default.createElement("div", { className: styles.root }, modifiedChildren);
};
exports.InputGroup = InputGroup;
// The later in the array the higher the priority for showing that element's border
const borderPriority = [
    '',
    'base',
    'hovered',
    'invalid',
    'focused',
];
const getStyles = () => ({
    root: (0, css_1.css)({
        display: 'flex',
        // Style the direct children of the component
        '> *': {
            '&:not(:first-child)': {
                // Negative margin hides the double-border on adjacent selects
                marginLeft: -1,
            },
            '&:first-child': {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            '&:last-child': {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            },
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0,
            },
            //
            position: 'relative',
            zIndex: borderPriority.indexOf('base'),
            // Adjacent borders are overlapping, so raise children up when hovering etc
            // so all that child's borders are visible.
            '&:hover': {
                zIndex: borderPriority.indexOf('hovered'),
            },
            '&:focus-within': {
                zIndex: borderPriority.indexOf('focused'),
            },
        },
    }),
    invalidChild: (0, css_1.css)({
        zIndex: borderPriority.indexOf('invalid'),
    }),
});
//# sourceMappingURL=InputGroup.js.map